/**
 * Ime datoteke iz glave `Content-Disposition` (T2162).
 *
 * Prednost ima RFC 5987 `filename*=UTF-8''…` — zaledje ga pošlje, ko ime nosi
 * šumnike ali umlaute (ime je v jeziku uporabnika); sicer navaden
 * `filename="…"`. Vrne `null`, ko glave ali imena ni, da klicatelj izbere
 * svoj nadomestek.
 *
 * Edini zapis pravila: od T2172 ga uporabljata tudi `ExportProgress.tsx` in
 * `shareApi.ts` (`downloadShareExport`), ki sta ga prej prepisovala sama.
 */
export function filenameFromContentDisposition(
  header: string | null | undefined,
): string | null {
  if (!header) return null;
  const utf8 = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      // Pokvarjen odstotni zapis — poskusi še navadno obliko.
    }
  }
  const plain = header.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : null;
}
